<template>
  <extensions-permission-guard :situation-id='situationId'>
    <v-container fluid>
      <api-key-prompt-overlay-container />
      <v-row>
        <v-col cols='12' lg='10' offset-lg='1'>
          <h2 class='title mb-3'>メルマガ設定({{ findService().label }})</h2>
          <permission-guard situation='mail_magazine_member_management'>
            <SyncSettingsFormContainer v-model='service' />
            <div class='mb-3 row'>
              <div class='ml-auto'>
                <SyncButtonContainer @create-session='addSession' />
              </div>
            </div>
            <v-divider class='mb-3'></v-divider>
            <div class='mb-3'>
              <OnamaeTableContainer :sessions='sessions' @update-session='updateSession' />
            </div>
          </permission-guard>
        </v-col>
      </v-row>
    </v-container>
  </extensions-permission-guard>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import ExtensionsPermissionGuard from '@/components/commons/ExtensionsPermissionGuard'
import { MAIL_MAGAZINE_MEMBERS_SITUATION_ID } from '@/mixins/site_permission_utils'
import PermissionGuard from '@/components/commons/PermissionGuard'
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'
import SyncSettingsFormContainer from '../../../../src/container/pages/MailMagazineSettings/SyncSettingFormContainer'
import SyncButtonContainer from '../../../../src/container/pages/MailMagazineSettings/SyncButtonContainer'
import OnamaeTableContainer from '../../../../src/container/pages/MailMagazineSettings/OnamaeTableContainer'
import ApiKeyPromptOverlayContainer
from '../../../../src/container/pages/MailMagazineSettings/ApiKeyPromptOverlayContainer'

export default {
  components: {
    ApiKeyPromptOverlayContainer,
    OnamaeTableContainer,
    SyncButtonContainer,
    SyncSettingsFormContainer,
    InfiniteLoading,
    ExtensionsPermissionGuard,
    PermissionGuard
  },
  data: () => {
    return {
      pageTitle: 'メルマガ配信設定',
      situationId: MAIL_MAGAZINE_MEMBERS_SITUATION_ID,
      mailMagazineServices: [
        { service: 'onamae', label: 'お名前メールマーケティング' }
      ],
      service: { isAutoSync: null },
      sessions: []
    }
  },
  mounted () {
    this.fetchService()
    this.fetchOnamaeSessions()
  },
  methods: {
    fetchService () {
      axios
        .get(`/api/mail_magazine_sync_settings/${this.$route.params.service}`)
        .then(({ data }) => {
          this.service = deserialize(data).data
        })
    },
    findService () {
      return this.mailMagazineServices.find(
        ({ service }) => service === this.$route.params.service
      )
    },
    fetchOnamaeSessions () {
      axios.get(`/api/onamae_mm_sessions`).then(({ data }) => {
        this.sessions = deserialize(data).data
      })
    },
    addSession (session) {
      this.sessions.unshift(session)
    },
    updateSession (updatedSession) {
      const index = this.sessions.findIndex(({ id }) => updatedSession.id === id)
      this.sessions.splice(index, 1, updatedSession)
    }
  }
}
</script>
